import { listGoalCategoryAdmin, listGoalSubCategoryAdmin, addGoalCategory, updateGoalCategory, deleteGoalCategory, addGoalSubCategory, updateGoalSubCategory, deleteGoalSubCategory } from "services/goalService";

import {
  fetchGoalCategories,
  setGoalLoader,
  goalSuccessMsg,
  goalErrorMsg,
  fetchGoalSubCategories,
} from "./reducer";

export const fetchGoalCategoryAdmin = () => async (dispatch: any) => {
  dispatch(setGoalLoader(true));

  try {
    const response = await listGoalCategoryAdmin();

    if (response?.success && response?.data) {
      const categories = Array.isArray(response.data)
        ? response.data
        : [response.data];

      dispatch(fetchGoalCategories(categories));
    } else {
      dispatch(
        goalErrorMsg({
          message: response?.message || "Failed to fetch goal categories",
          id: Date.now(),
        })
      );
    }
  } catch (error: any) {
    dispatch(
      goalErrorMsg({
        message: error?.message || "Error while fetching goal categories",
        id: Date.now(),
      })
    );
  } finally {
    dispatch(setGoalLoader(false));
  }
};
export const fetchGoalSubCategoryAdmin = () => async (dispatch: any) => {
    dispatch(setGoalLoader(true));
  
    try {
      const response = await listGoalSubCategoryAdmin();
  
      if (response?.success && response?.data) {
        const subCategories = Array.isArray(response.data)
          ? response.data
          : [response.data];
  
        dispatch(fetchGoalSubCategories(subCategories));
      } else {
        dispatch(
          goalErrorMsg({
            message: response?.message || "Failed to fetch goal sub-categories",
            id: Date.now(),
          })
        );
      }
    } catch (error: any) {
      dispatch(
        goalErrorMsg({
          message: error?.message || "Error while fetching goal sub-categories",
          id: Date.now(),
        })
      );
    } finally {
      dispatch(setGoalLoader(false));
    }
  };

export const addGoalCategoryAdmin = (data: { category_name: string; category_order: number }) => async (dispatch: any) => {
  dispatch(setGoalLoader(true));

  try {
    const response = await addGoalCategory(data);

    if (response?.success) {
      dispatch(
        goalSuccessMsg({
          message: response?.message || "Goal category has been saved successfully",
          id: response?.data || Date.now(),
        })
      );
      // Optionally refresh the categories list after adding
      dispatch(fetchGoalCategoryAdmin());
      return response;
    } else {
      dispatch(
        goalErrorMsg({
          message: response?.message || "Failed to add goal category",
          id: Date.now(),
        })
      );
      return response;
    }
  } catch (error: any) {
    const errorMessage =
      error?.message || error?.response?.data?.message || "Something went wrong while adding goal category";
    dispatch(
      goalErrorMsg({
        message: errorMessage,
        id: Date.now(),
      })
    );
    return {
      success: false,
      message: errorMessage,
    };
  } finally {
    dispatch(setGoalLoader(false));
  }
};

export const updateGoalCategoryAdmin = (category_id: number, data: { category_name: string; category_order: number; status: string }) => async (dispatch: any) => {
  dispatch(setGoalLoader(true));

  try {
    const response = await updateGoalCategory(category_id, data);

    if (response?.success) {
      dispatch(
        goalSuccessMsg({
          message: response?.message || "Goal category has been updated successfully",
          id: category_id || Date.now(),
        })
      );
      // Refresh the categories list after updating
      dispatch(fetchGoalCategoryAdmin());
      return response;
    } else {
      dispatch(
        goalErrorMsg({
          message: response?.message || "Failed to update goal category",
          id: Date.now(),
        })
      );
      return response;
    }
  } catch (error: any) {
    const errorMessage =
      error?.message || error?.response?.data?.message || "Something went wrong while updating goal category";
    dispatch(
      goalErrorMsg({
        message: errorMessage,
        id: Date.now(),
      })
    );
    return {
      success: false,
      message: errorMessage,
    };
  } finally {
    dispatch(setGoalLoader(false));
  }
};

export const deleteGoalCategoryAdmin = (category_id: number) => async (dispatch: any) => {
  dispatch(setGoalLoader(true));

  try {
    const response = await deleteGoalCategory(category_id);

    if (response?.success) {
      dispatch(
        goalSuccessMsg({
          message: response?.message || "Goal category has been deleted successfully",
          id: category_id || Date.now(),
        })
      );
      // Refresh the categories list after deleting
      dispatch(fetchGoalCategoryAdmin());
      return response;
    } else {
      dispatch(
        goalErrorMsg({
          message: response?.message || "Failed to delete goal category",
          id: Date.now(),
        })
      );
      return response;
    }
  } catch (error: any) {
    const errorMessage =
      error?.message || error?.response?.data?.message || "Something went wrong while deleting goal category";
    dispatch(
      goalErrorMsg({
        message: errorMessage,
        id: Date.now(),
      })
    );
    return {
      success: false,
      message: errorMessage,
    };
  } finally {
    dispatch(setGoalLoader(false));
  }
};

export const addGoalSubCategoryAdmin = (data: { category_name: string; category_order: number; parent_id: number }) => async (dispatch: any) => {
  dispatch(setGoalLoader(true));

  try {
    const response = await addGoalSubCategory(data);

    if (response?.success) {
      dispatch(
        goalSuccessMsg({
          message: response?.message || "Goal sub category has been saved successfully",
          id: response?.data || Date.now(),
        })
      );
      // Refresh the sub categories list after adding
      dispatch(fetchGoalSubCategoryAdmin());
      return response;
    } else {
      dispatch(
        goalErrorMsg({
          message: response?.message || "Failed to add goal sub category",
          id: Date.now(),
        })
      );
      return response;
    }
  } catch (error: any) {
    const errorMessage =
      error?.message || error?.response?.data?.message || "Something went wrong while adding goal sub category";
    dispatch(
      goalErrorMsg({
        message: errorMessage,
        id: Date.now(),
      })
    );
    return {
      success: false,
      message: errorMessage,
    };
  } finally {
    dispatch(setGoalLoader(false));
  }
};

export const updateGoalSubCategoryAdmin = (subcategory_id: number, data: { category_name: string; category_order: number; status: string; parent_id: number }) => async (dispatch: any) => {
  dispatch(setGoalLoader(true));

  try {
    const response = await updateGoalSubCategory(subcategory_id, data);

    if (response?.success) {
      dispatch(
        goalSuccessMsg({
          message: response?.message || "Goal sub category has been updated successfully",
          id: subcategory_id || Date.now(),
        })
      );
      // Refresh the sub categories list after updating
      dispatch(fetchGoalSubCategoryAdmin());
      return response;
    } else {
      dispatch(
        goalErrorMsg({
          message: response?.message || "Failed to update goal sub category",
          id: Date.now(),
        })
      );
      return response;
    }
  } catch (error: any) {
    const errorMessage =
      error?.message || error?.response?.data?.message || "Something went wrong while updating goal sub category";
    dispatch(
      goalErrorMsg({
        message: errorMessage,
        id: Date.now(),
      })
    );
    return {
      success: false,
      message: errorMessage,
    };
  } finally {
    dispatch(setGoalLoader(false));
  }
};

export const deleteGoalSubCategoryAdmin = (subcategory_id: number) => async (dispatch: any) => {
  dispatch(setGoalLoader(true));

  try {
    const response = await deleteGoalSubCategory(subcategory_id);

    if (response?.success) {
      dispatch(
        goalSuccessMsg({
          message: response?.message || "Goal sub category has been deleted successfully",
          id: subcategory_id || Date.now(),
        })
      );
      // Refresh the sub categories list after deleting
      dispatch(fetchGoalSubCategoryAdmin());
      return response;
    } else {
      dispatch(
        goalErrorMsg({
          message: response?.message || "Failed to delete goal sub category",
          id: Date.now(),
        })
      );
      return response;
    }
  } catch (error: any) {
    const errorMessage =
      error?.message || error?.response?.data?.message || "Something went wrong while deleting goal sub category";
    dispatch(
      goalErrorMsg({
        message: errorMessage,
        id: Date.now(),
      })
    );
    return {
      success: false,
      message: errorMessage,
    };
  } finally {
    dispatch(setGoalLoader(false));
  }
};